module.exports = {
	MESSAGE: 'MESSAGE',
	RESET_INFORMATION: 'RESET_INFORMATION'
}



// WEBPACK FOOTER //
// ./src/home/constants/InformationConstants.js